import { render, staticRenderFns } from "./UploadMaterialDialog.vue?vue&type=template&id=cf4d509a&scoped=true"
import script from "./UploadMaterialDialog.vue?vue&type=script&lang=js"
export * from "./UploadMaterialDialog.vue?vue&type=script&lang=js"
import style0 from "./UploadMaterialDialog.vue?vue&type=style&index=0&id=cf4d509a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf4d509a",
  null
  
)

export default component.exports